import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { heroKpiIconSx, FONT, SIZE, WEIGHT, NAVY, SUBTLE, BORDER, WHITE } from '../dashboard/dashboardStyles';

/* Tile pieces shared by the PTL pages (Today's Shipments, PoD Analytics), so they look the same. */

export const tileMetaSx = { fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE };
const valueSx = { fontFamily: FONT, fontWeight: WEIGHT.extra, fontSize: SIZE['3xl'], lineHeight: 1, color: NAVY, fontVariantNumeric: 'tabular-nums' };

/** Thin bar split into coloured segments: [{ key, value, color }]. */
export function SplitBar({ segments, label }) {
  const total = segments.reduce((s, x) => s + (x.value || 0), 0);
  return (
    <Box role='img' aria-label={label} sx={{ display: 'flex', height: 6, borderRadius: 3, overflow: 'hidden', bgcolor: BORDER }}>
      {total > 0 && segments.map((s) => (s.value ? <Box key={s.key} sx={{ width: `${(100 * s.value) / total}%`, bgcolor: s.color }} /> : null))}
    </Box>
  );
}

/**
 * Non-clickable stat tile (for tiles holding their own controls): icon + label + hint on the left, the value on
 * the right, then `bar` and `footer`. `value` undefined = loading.
 */
export function StatTile({ accent, icon, label, hint, value, bar, footer }) {
  const loading = value === undefined;
  return (
    <Box sx={{ p: '16px', borderRadius: '16px', border: `1px solid ${BORDER}`, bgcolor: WHITE, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
          <Box sx={heroKpiIconSx(accent)}>{icon}</Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: NAVY }}>{label}</Typography>
            <Typography component='div' sx={tileMetaSx}>{loading ? <Skeleton variant='text' width={140} /> : hint}</Typography>
          </Box>
        </Box>
        {loading
          ? <Skeleton variant='text' width={52} sx={{ fontSize: SIZE['3xl'], lineHeight: 1 }} />
          : <Typography sx={valueSx}>{value}</Typography>}
      </Box>
      <Box sx={{ mt: 1.75 }}>{loading ? <Skeleton variant='rectangular' height={6} sx={{ borderRadius: 3 }} /> : bar}</Box>
      <Box sx={{ mt: 1.25 }}>{loading ? <Skeleton variant='text' width={180} /> : footer}</Box>
    </Box>
  );
}
